<template>
  <div>
    <header>
      <div class="inner">
        <div class="logo flex">
          <router-link to="/">
            <img src="@/assets/images/header/logo-new2.svg" alt="Logo Img" />
          </router-link>
          <router-link to="/">
            <img src="@/assets/images/header/ageTech_Platform_logo.png" alt="Logo Img" />
          </router-link>
          <!-- <h5 style="white-space: nowrap;">디지털 뉴에이징연구소</h5> -->
        </div>

        <nav class="gnb">
          <ul @mouseover="isShowSub = true">
            <li
              v-for="(item, index) in items"
              :key="index"
              :class="[item.mobileMenu, {'userH4': getUser.roleName == $role.USER, 'adminH4':getUser.roleName == $role.ADMIN, 'corpH4':getUser.roleName == $role.CORP}]"
            >
              <router-link :class="item.menuClass" :to="item.link" >
                <h4>{{ item.title }}</h4>
              </router-link>
            </li>

            <transition name="fade">
              <div
                class="dropDownMenu"
                v-if="isShowSub"
                @click="isShowSub = false"
                @mouseleave="isShowSub = false"
              >
                <ul>
                  <li
                    v-for="(item, index) in items"
                    :key="index"
                    :class="[item.dropClass, item.mobileMenu , {'userDropdown': getUser.roleName == $role.USER, 'adminDropdown':getUser.roleName == $role.ADMIN, 'corpDropdown':getUser.roleName == $role.CORP}]"
                  >
                    {{ item.title }}
                    <ul>
                      <template v-for="(subItem, index) in item.sub">
                        <li v-if="!subItem.forTopMenu" :key="index">
                          <router-link
                            :to="subItem.link"
                            :class="dropMenuClass(subItem)"
                          >
                            {{ subItem.title }}
                          </router-link>
                        </li>
                      </template>
                    </ul>
                  </li>
                </ul>
              </div>
            </transition>
          </ul>
        </nav>

        <div class="headerBtn">
          <!-- <button class="alarmBtn" @click="alarmBtn()" v-show="isAuth && getUser != null && (getUser.roleName == $role.CORP)">1</button> -->
          <!-- <ModalRejectAlarm v-if="isShowModalRejectAlarm" @modal-closed='handleModalClosed'/> -->
          <button
            class="buttonBnt"
            @click.prevent="
              (isShowAlert = !isShowAlert),
                (isShowProfile = false),
                (showNoti = false)
            "
            v-show="
              isAuth &&
                getUser != null &&
                (getUser.roleName == $role.USER ||
                  getUser.roleName == $role.CORP)
            "
          >
            <i class="ic ic--bell">
              <i
                class="ic ic--alert"
                v-if="showNoti && rejectNoties.length > 0"
              ></i>
            </i>
            <PopupHeaderNotify />
            <!-- 
            <transition name="fade" v-if="rejectNoties.length > 0">
              <div class="profileDrop" v-if="isShowAlert">
                <div class="box-alert">
                  <div class="item-alert">
                    <p>
                      등록하신 제품·서비스가 거절되었습니다.
                    </p>
                    <p class="alignR mt-5">
                      <router-link
                        style="display: inline-block;"
                        :to="
                          rejectNoties[0].type === 'service'
                            ? '/corp/productEnroll/' + rejectNoties[0].IDX
                            : '/corp/serviceEnroll/' + rejectNoties[0].IDX
                        "
                      >
                        <button class="btn-main btn-primary bordered btn-small">
                          확인하러가기
                        </button>
                      </router-link>
                      <button
                        class="btn-main btn-outline-secondary bordered ml-3 btn-small"
                      >
                        취소
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </transition>
            -->
          </button>

          <button
            class="profilBtn"
            @click.prevent="gotoMyMatching"
            v-show="
              isAuth &&
                getUser != null &&
                (getUser.roleName == $role.USER ||
                  getUser.roleName == $role.CORP)
            "
          >
            <!-- <transition name="fade">
              <div
                class="profileDrop"
                v-if="isShowProfile && profileSubmenu.length > 0"
              >
                <ul>
                  <li v-for="(menu, i) in profileSubmenu" :key="i">
                    <router-link :to="menu.link">{{ menu.title }}</router-link>
                  </li>
                </ul>
              </div>
            </transition> -->
          </button>
          <div v-if="!isAuth" class="flex">
            <router-link class="btnFont loginBtn" to="/auth">
              로그인
            </router-link>
            <router-link class="btnFont joinBtn" to="/auth/join">
              회원가입
            </router-link>
          </div>
          <div v-else>
            <a class="btnFont joinBtn" @click="onClickSignout">로그아웃</a>
          </div>
        </div>
      </div>
      <div class="mobileInner" :class="{ active: isActive }">
        <div class="flex" style="align-items: center;">
          <div class="mobileLogo flex">
            <router-link to="/">
              <img src="@/assets/images/header/logo-new2.svg" alt="Logo Img" />
            </router-link>
            <router-link to="/">
              <img
                src="@/assets/images/header/ageTech_Platform_logo.png"
                alt="Logo Img"
              />
            </router-link>
          </div>
          <nav class="mobileGnb">
            <div class="menuBox" @click="mobileMenuActive">
              <span class="mobileMenu">
                <span class="hamburger"></span>
              </span>
            </div>
          </nav>
        </div>
        <transition name="fade">
          <div class="dropDownMobileMenu" v-if="isShowMobileMenu">
            <ul>
              <li
                name="dropDownMobileTitle"
                v-for="(item, index) in items"
                :key="index"
                :class="item.dropClass"
                @click="mobileSubMenuActive(index)"
              >
                {{ item.title }}
                <transition name="fade">
                  <ul v-if="isShowSubMobileMenu && index == temp">
                    <!-- li 개별 클릭, isShowMobileMenu 클릭 시 메뉴 닫기 실행 오류 -->
                    <li
                      v-for="(subItem, index) in item.sub"
                      :key="index"
                      v-show="!subItem.forTopMenu"
                      @click="mobileMenuActive"
                    >
                      <router-link
                        :to="subItem.link"
                        :class="dropMenuClass(subItem)"
                        >{{ subItem.title }}</router-link
                      >
                    </li>
                  </ul>
                </transition>
              </li>
            </ul>
            <div class="mobileLoginBtn">
              <div v-if="!isAuth" class="flex btnBox">
                <router-link class="btnFont redBtn" to="/auth"
                  >로그인</router-link
                >
                <router-link class="btnFont redborderBtn" to="/auth/join"
                  >회원가입</router-link
                >
              </div>
              <div v-else>
                <a class="btnFont joinBtn" @click="onClickSignout">로그아웃</a>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </header>

    <nav
      class="topMenu"
      v-if="currentItem != null"
      :class="{ subHidden: isSubHidden }"
      @click="subMenuHidden"
    >
      <ul>
        <router-link
          tag="li"
          v-for="(subItem, index) in currentItem.sub"
          :key="index"
          :class="topMenuClass(subItem)"
          :to="subItem.link"
          :target="subItem.target"
        >
          {{ subItem.title }}
        </router-link>
      </ul>
      <div class="mobileSubMenuBtnBox">
        <button @click="subMenuHidden"></button>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import * as jwtUtil from "@/utils/jwtUtil";
import {
  CORP_PROFILE_SUB_MENU,
  MENU_ITEMS,
  USER_PROFILE_SUB_MENU,
} from "@/data/header";
import ModalRejectAlarm from "@/components/managementPopup/ModalRejectAlarm";
import PopupHeaderNotify from "./PopupHeaderNotify.vue";

export default {
  components: { PopupHeaderNotify },
  data() {
    return {
      isShowSub: false,
      isShowProfile: false,
      isShowAlert: false,
      isActive: false,
      isShowMobileMenu: false,
      isShowSubMobileMenu: false,
      temp: 0,
      isSubHidden: false,
      isShowModalRejectAlarm: false,
    };
  },
  watch: {
    $route(to) {
      var self = this;
      if (
        ["/", "/auth", "/auth/join", "/error/404", "/error/403"].includes(
          to.fullPath,
        )
      ) {
        self.currentItem = null;
        self.currentSubItem = null;
      } else {
        for (var i = 0; i < self.items.length; i++) {
          var item = self.items[i];
          var found = false;

          if (item.link === to.fullPath) {
            self.currentItem = item;
            self.currentSubItem = null;
            found = true;
          }

          if (item.sub) {
            for (var j = 0; j < item.sub.length; j++) {
              var subItem = item.sub[j];
              if (subItem.link === to.fullPath) {
                self.currentItem = item;
                self.currentSubItem = subItem;
                found = true;
                break;
              }
            }
          }

          if (found) break;
        }
      }
    },
  },
  computed: {
    ...mapGetters("header", ["getCurrentItem", "getCurrentSubItem"]),
    ...mapGetters("auth", [
      "isAuth",
      "getUser",
      "getRejectNoties",
      "getShowNoti",
    ]),
    profileSubmenu() {
      switch (this.getUser.roleName) {
        case this.$role.USER:
          return USER_PROFILE_SUB_MENU;
        case this.$role.CORP:
          return CORP_PROFILE_SUB_MENU;
        default:
          return [];
      }
    },
    rejectNoties: {
      get() {
        return this.getRejectNoties;
      },
    },
    showNoti: {
      get() {
        return this.getShowNoti;
      },
      set(value) {
        this.setShowNoti(value);
      },
    },
    currentItem: {
      get() {
        return this.getCurrentItem;
      },
      set(value) {
        this.setCurrentItem(value);
      },
    },
    currentSubItem: {
      get() {
        return this.getCurrentSubItem;
      },
      set(value) {
        this.setCurrentSubItem(value);
      },
    },
    items() {
      if (this.isAuth == true && this.getUser != null) {
        switch (this.getUser.roleName) {
          case this.$role.USER:
            return MENU_ITEMS.USER_MENU_ITEMS;
          case this.$role.CORP:
            return MENU_ITEMS.CORP_MENU_ITEMS;
          case this.$role.ADMIN:
            return MENU_ITEMS.ADMIN_MENU_ITEMS;
          case this.$role.MANAGER:
            return MENU_ITEMS.MANAGER_MENU_ITEMS;
        }
      }

      return MENU_ITEMS.COMMON_MENU_ITEMS;
      // return MENU_ITEMS.MANAGER_MENU_ITEMS
      // return MENU_ITEMS.USER_MENU_ITEMS
    },
    isSelected(item) {
      if (this.currentSubItem.link === item.link) {
        return item.topClass;
      } else {
        return "";
      }
    },
  },
  methods: {
    ...mapMutations("header", ["setCurrentItem", "setCurrentSubItem"]),
    ...mapMutations("auth", ["setShowNoti"]),
    ...mapActions("auth", ["signout"]),
    gotoMyMatching() {
      if (["/user/myMatching", "/corp/myMatching"].includes(this.$route.path))
        return;
      var user = this.getUser;
      if (user.roleName === "ROLE_USER") {
        this.$router.push("/user/myMatching");
        return;
      }

      if (user.roleName === "ROLE_CORP") {
        this.$router.push("/corp/myMatching");
        return;
      }
    },
    dropMenuClass(item) {
      if (
        item.link != null &&
        this.currentSubItem != null &&
        this.currentSubItem.link != null &&
        item.link == this.currentSubItem.link
      ) {
        return "menu-item " + (item.dropClass || "") + " active";
      } else {
        return "menu-item " + (item.dropClass || "");
      }
    },
    topMenuClass(item) {
      if (
        item.link != null &&
        this.currentSubItem != null &&
        this.currentSubItem.link != null &&
        item.link == this.currentSubItem.link
      ) {
        return item.topClass + " active";
      } else {
        return item.topClass;
      }
    },
    onClickSignout() {
      if (this.isShowProfile) this.isShowProfile = !this.isShowProfile;

      var refreshToken = localStorage.getItem(
        jwtUtil.LOCAL_STORAGE_KEY_REFRESH_TOKEN,
      );
      var user = this.getUser;
      var userIdx = 0;
      if (user != null) {
        userIdx = user.idx;
      }

      this.signout({
        userIdx: userIdx,
        refreshToken: refreshToken,
      }).then(() => {
        this.$alert("알림", "로그아웃 되었습니다.", "확인", {
          closed: () => {
            this.$router.replace({ path: "/" });
          },
        });
      });
    },
    mobileMenuActive() {
      this.isActive = !this.isActive;
      this.isShowMobileMenu = !this.isShowMobileMenu;
      var bodyFixed = document.body;
      if (this.isShowMobileMenu == true) {
        bodyFixed.classList.add("fixed");
      } else {
        bodyFixed.classList.remove("fixed");
      }
    },
    mobileSubMenuActive(index) {
      var dropDownMobileTitles = document.getElementsByName(
        "dropDownMobileTitle",
      );

      if (dropDownMobileTitles[index].classList.contains("active")) {
        dropDownMobileTitles[index].classList.remove("active");
      } else {
        dropDownMobileTitles[index].classList.add("active");
      }

      this.temp = index;
      this.isShowSubMobileMenu = !this.isShowSubMobileMenu;
    },
    subMenuHidden() {
      this.isSubHidden = !this.isSubHidden;
    },
    alarmBtn() {
      this.isShowModalRejectAlarm = true;
    },
    handleModalClosed(value) {
      if (value === ModalRejectAlarm.name) {
        this.isShowModalRejectAlarm = false;
      }
    },
    handleShowNoti() {
      var check = this.showNoti;
      this.showNoti = !check;
    },
  },
};
</script>

<!-- padding: 0 70px; -->
<style scoped>
.dropDownMenu > ul > li:nth-of-type(1) {
  padding: 0 70px;
}

.dropDownMenu > ul {
  padding-right: 100px;
}

.menuBox > .mobileMenu {
  position: absolute;
  width: 30px;
  height: 20px;
  background: transparent;
  z-index: 101;
  transition: 0.5s ease-in-out;
  top: 18px;
  right: 14px;
  opacity: 1;
}

.menuBox > .mobileMenu:after {
  position: absolute;
  width: 0;
  height: 0;
  background-color: #e53b28;
  border-radius: 50% 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0.5;
  z-index: -1;
}

.hamburger {
  position: absolute;
  top: 9px;
  right: 0px;
  width: 30px;
  height: 2px;
  background: #000;
  display: block;
  transform-origin: center;
  transition: 0.5s ease-in-out;
}

.hamburger:before,
.hamburger:after {
  transition: 0.5s ease-in-out;
  content: "";
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  background: #000;
}

.hamburger:before {
  top: -7px;
}

.hamburger:after {
  bottom: -7px;
}

.mobileInner.active .hamburger {
  transform: rotate(45deg);
}

.mobileInner.active .hamburger:after {
  transform: rotate(90deg);
  bottom: 0;
}

.mobileInner.active .hamburger:before {
  transform: rotate(90deg);
  top: 0;
}

.mobileInner.active .mobileLogo {
  opacity: 0;
}

.menu-item {
  white-space: nowrap;
}

.dropDownMobileMenu {
  height: 100vh;
  width: 100vw;
  position: fixed;
  z-index: 50;
  background: #fff;
  left: 0;
  top: 0;
  overflow: auto;
  padding: 58px 0 50px;
}

.mobileInner.active .menuBox > .mobileMenu {
  top: 14px;
}

@media screen and (max-width: 1288px) {
  .dropDownMenu > ul {
    padding-right: 0;
  }
}

.headerBtn {
  position: relative;
}

header>.inner>.gnb>ul>li.userH4 {
  padding: 3.9rem 1.6rem;
  padding: 1rem 1rem;
}
header>.inner>.gnb>ul>li.adminH4 {
  padding: 3.9rem 0.9rem;
  padding: 1rem 1rem;
}

header>.inner>.gnb>ul>li.corpH4 {
  padding: 1rem 1rem;
}
li.userH4 a h4 {
  font-size: 2.8rem;
}
li.adminH4 a h4 {
  font-size: 2.8rem;
}
li.corpH4 a h4 {
  font-size: 2.8rem;
}


</style>
